import { CoPilotNavigationTab } from 'features/co-pilot/co-pilot-routes';
import { useEffect } from 'react';
import useAppBarNavigationStore from 'stores/app-bar-navigation-store';

export const useCoPilotTabRouteSync = (tab: CoPilotNavigationTab) => {
  const activeTab = useAppBarNavigationStore((state) => state.activeTab);
  const setActiveTab = useAppBarNavigationStore((state) => state.setActiveTab);

  useEffect(() => {
    if (activeTab !== tab) {
      setActiveTab(tab, false);
    }
  }, [activeTab, setActiveTab, tab]);
};
